import { useCallback, useSyncExternalStore } from 'react';

/**
 * Subscribe to a CSS media query. Reads the current value synchronously on the first
 * render (no effect round-trip), so a layout that branches on it never paints the wrong
 * arrangement first — the drawer shell would otherwise flash its desktop sidebar on a phone.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', notify);
      return () => mql.removeEventListener('change', notify);
    },
    [query],
  );
  const read = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
  return useSyncExternalStore(subscribe, read, () => false);
}
